import { render } from "./AdminAccommodationInquiryFormDialog.vue?vue&type=template&id=484c5568&scoped=true&ts=true"
import script from "./AdminAccommodationInquiryFormDialog.vue?vue&type=script&lang=ts"
export * from "./AdminAccommodationInquiryFormDialog.vue?vue&type=script&lang=ts"

import "./AdminAccommodationInquiryFormDialog.vue?vue&type=style&index=0&id=484c5568&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484c5568"]])

export default __exports__